import axios from 'axios'
import { getToken } from '@/utils/auth'

export function arrayCompare(source, target) {
  return (
    source.length === target.length &&
    source.every((item, index) => item.op === target[index].op)
  )
}

export function isJSON(val) {
  if (typeof val !== 'string') {
    return false
  }
  try {
    const obj = JSON.parse(val)
    if (Object.prototype.toString.call(obj) === '[object Object]') {
      return true
    } else {
      return false
    }
  } catch (e) {
    return false
  }
}

// 时间转换函数
// dateFormat("yyyy-MM-dd hh:mm:s 第q季度",time)
// dateFormat("yyyy年MM月dd日 hh时mm分ss秒S毫秒 第q季度",time)
export function dateFormat(fmt, date) {
  var o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      )
    }
  }
  return fmt
}

export function getQueryString(name) {
  var reg = new RegExp('(^|&|\\?)' + name + '=([^&]*)(&|$)', 'i')
  var r = window.location.href.match(reg)
  if (r != null) {
    return unescape(r[2])
  }
  return null
}

export function exportExcel(
  params,
  filename,
  url = this.exportUrl,
  method = 'GET',
  headers
) {
  // Excel导出功能,文件流下载
  return new Promise((resolve, reject) => {
    return axios({
      url: `${process.env.VUE_APP_API_URL}${url}`,
      responseType: 'blob',
      method: method,
      headers: Object.assign(
        {
          'Content-Type': 'application/json',
          access_token: getToken()
        },
        headers
      ),
      params,
      data: JSON.stringify(params)
    })
      .then((res, res2, res3) => {
        if (res.status === 200 && res.request.readyState === 4) {
          const downloadLink = window.document.createElement('a')
          // const fileName = res.headers['content-disposition'].match(/filename="(.+)"/)[1]
          const fileName = `${filename || '未命名'}.xlsx`

          downloadLink.href = window.URL.createObjectURL(res.data)
          downloadLink.download = fileName
          document.body.appendChild(downloadLink)
          downloadLink.click()
          document.body.removeChild(downloadLink)
          resolve('下载成功')
        } else {
          reject('下载失败')
          // this.$message({
          //   type: 'error',
          //   message: '下载失败'
          // })
        }
      })
      .catch(error => {
        console.log(error)
      })
  })
}

export function deepClone(o, c) {
  const toString = Object.prototype.toString
  toString.call(o) === '[object Array]' ? (c = c || []) : (c = c || {})
  for (const i in o) {
    if (typeof o[i] === 'object') {
      // 要考虑深复制问题了
      if (Array.isArray(o[i])) {
        // 这是数组
        c[i] = []
      } else {
        // 这是对象
        c[i] = {}
      }
      deepClone(o[i], c[i])
    } else {
      c[i] = o[i]
    }
  }
  return c
}
/*
 * 清除对象空属性
 * */
export function cleanObj(o) {
  for (const key of Object.keys(o)) {
    const item = o.hasOwnProperty(key) && JSON.stringify(o[key])
    if (item === '""' || item === '[]' || item === '{}') {
      delete o[key]
    }
  }
  return o
}

export function ext() {
  // eslint-disable-next-line
  var target = arguments[0] || {},
    i = 1,
    length = arguments.length,
    deep = false,
    options,
    name,
    src,
    copy
  if (typeof target === 'boolean') {
    deep = target
    target = arguments[1] || {}
    i = 2
  }
  if (typeof target !== 'object' && typeof target !== 'function') {
    target = {}
  }
  if (length === i) {
    target = this
    --i
  }
  for (; i < length; i++) {
    if ((options = arguments[i]) != null) {
      for (name in options) {
        src = target[name]
        copy = options[name]
        if (target === copy) {
          continue
        }
        if (
          deep &&
          copy &&
          (typeof copy === 'object' || Array.isArray(copy)) &&
          !copy.nodeType
        ) {
          var clone =
            src && (typeof src === 'object' || Array.isArray(src))
              ? src
              : Array.isArray(copy)
              ? []
              : {}
          target[name] = ext(deep, clone, copy)
        } else if (copy !== undefined) {
          target[name] = copy
        }
      }
    }
  }
  return target
}

// 无树状结构数组转换树状节点方法
export function arrayToTree(
  treeArray,
  idKey = 'id',
  pidKey = 'pid',
  childrenKey = 'children'
) {
  const r = []
  const tmpMap = {}
  treeArray = deepClone(treeArray)

  for (let i = 0, l = treeArray.length; i < l; i++) {
    // 以每条数据的id作为obj的key值，数据作为value值存入到一个临时对象里面
    tmpMap[treeArray[i][idKey]] = treeArray[i]
  }

  for (let j = 0, l = treeArray.length; j < l; j++) {
    const key = tmpMap[treeArray[j][pidKey]]

    // 循环每一条数据的pid，假如这个临时对象有这个key值，就代表这个key对应的数据有children，需要Push进去
    if (key) {
      if (!key[childrenKey]) {
        key[childrenKey] = [treeArray[j]]
      } else {
        const obj = {}
        const bindArr = [...key[childrenKey], treeArray[j]]
          .sort(item => item[childrenKey])
          .reverse()
        key[childrenKey] = bindArr.reduce((cur, next) => {
          obj[next[idKey]] ? '' : (obj[next[idKey]] = true && cur.push(next))
          return cur
        }, [])
      }
    } else {
      // 如果没有这个Key值，那就代表没有父级,直接放在最外层
      r.push(treeArray[j])
    }
  }
  return r
}

export function findValByKey(data, val, key = 'id', childrenKey = 'children') {
  for (const i in data) {
    if (data[i][key] && data[i][key] === val) {
      return data[i]
    }
    if (data[i][childrenKey] && data[i][childrenKey].length) {
      var result = findValByKey(data[i][childrenKey], val, key, childrenKey)
      if (result !== undefined) return result
    }
  }
}

export function createDownloadLink(res = {}, { fileName }) {
  const downloadLink = window.document.createElement('a')
  let filename =
    res.headers &&
    res.headers.hasOwnProperty('content-disposition') &&
    res.headers['content-disposition'].match(/filename="(.+)"/)[1]
  if (!filename) {
    filename = fileName || 'file.xls'
  }
  const fileUrl = res.data && window.URL.createObjectURL(res.data)
  downloadLink.href = fileUrl
  downloadLink.download = filename
  document.body.appendChild(downloadLink)
  downloadLink.click()
  document.body.removeChild(downloadLink)
  window.URL.revokeObjectURL(fileUrl)
}

// export function loadComponent(url) {
//   if (process.env.NODE_ENV === 'development') {
//     return require('@/views' + url).default
//   } else {
//     return () => import('@/views' + url)
//   }
// }

/**
 * Remove an item from an array
 */
export function remove(arr, item) {
  if (arr.length) {
    const index = arr.indexOf(item)
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}
